import { StoreManifestArgs } from "../../../pages/Manifest/ManifestConstant";
import {
  ApiResponse,
  DdStorePerformanceUIResponse,
  FieldValidationUIResponse,
  FilterValuesByFieldResponse,
  StoreManifestUIResponse,
} from "../../models/ApiResponse";
import { StorePackageValidateRequest } from "../../models/requestModels/StoreManifestValidationRequest";
import { AddStorePkgRequest } from "../../models/requestModels/storePkgRequest";
import { axiosRequests } from "../axiosRequest";

export const StoreManifestAgent = {
  getAllDdStore: () => axiosRequests.get<DdStorePerformanceUIResponse>
      (`/fdc-commandops/dedicated-delivery/fetch/stores`),
  getStoreManifestData: (args: StoreManifestArgs) => {
        return axiosRequests.post<StoreManifestUIResponse>(
          "/fdc-commandops/store-manifest",
          {
            storePrimaryId: args.storePrimaryId,
            page_size: args.pageSize,
            page_index: args.pageIndex,
            start_date: args.startDate,
            end_date: args.endDate,
            filters: args.filters,
          }
        );
      },
  fetchValuesByField: (
        startDate: string,
        endDate: string,
        columnName: string,
        storeId: number
      ) => {
        return axiosRequests.getWithQueryParam<FilterValuesByFieldResponse>(
          "/fdc-commandops/store-manifest/fetch/field-options",
          {
            params: {
              start_date: startDate,
              end_date: endDate,
              field_name: columnName,
              store_id: storeId,
            },
          }
        );
      },
  validateNewStorePacakge: (validationReq: StorePackageValidateRequest) => axiosRequests
      .post<FieldValidationUIResponse>
      ("/fdc-commandops/store-manifest/new/package/validate", validationReq),
  submitNewStorePacakge: (newPkgReq: AddStorePkgRequest) => axiosRequests.post<ApiResponse>
  ("/fdc-commandops/store-manifest/new/package", newPkgReq),
};
